export default "__VITE_ASSET__uco2ysbb__"